import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { LocaleProvider } from "./i18n/context";
import { MontavimasPage } from "./pages/MontavimasPage";
import "./index.css";

const app = (
  <StrictMode>
    <LocaleProvider>
      <MontavimasPage />
    </LocaleProvider>
  </StrictMode>
);

function mount() {
  const elem = document.getElementById("root");
  if (!elem) return;

  if (import.meta.hot) {
    import.meta.hot.dispose(() => {});
    const root = (import.meta.hot.data.root ??= createRoot(elem));
    root.render(app);
  } else if (elem.hasChildNodes()) {
    // Production HTML is pre-rendered at build time — attach to it.
    hydrateRoot(elem, app);
  } else {
    createRoot(elem).render(app);
  }
}

if (document.getElementById("root")) {
  mount();
} else {
  document.addEventListener("DOMContentLoaded", mount);
}
